export default "__VITE_ASSET__B0uJQ77K__"